module.exports = __webpack_public_path__ + "static/media/mn-logo.787ee8b9.svg";